<template>
    <vue-editor :value="value" :editor-toolbar="customToolbar" @input="onEditorUpdate"/>
</template>

<script>
import { VueEditor } from "vue2-editor";


export default {
    components: {
        VueEditor
    },
    props: ["value"],
    data() {
        return {
            customToolbar: [
                ['bold', 'italic', 'underline'],
                ['blockquote'],
                [{ 'header': 1 }, { 'header': 2 }],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                ['clean'],
                ['link', 'image']
            ]
        }
    },
    methods: {
        onEditorUpdate: function(newVal){
            this.$emit('input', newVal);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Editor.vue